export default __webpack_public_path__ + "static/media/Icon-Bills.e6fba29d.svg";